// extracted by mini-css-extract-plugin
export default {"mealTable":"wcu0nX6mPMIPV73e9KwS"};